import React from 'react';

export type SortAccessor = string | ((row: any) => unknown);

const sortableHeader = (
  label: React.ReactNode,
  accessor: SortAccessor,
  onSort: (sortAccessor: SortAccessor) => void
) => (
  <button
    type="button"
    className="m-0 cursor-pointer border-0 bg-transparent p-0 text-inherit [font:inherit]"
    onClick={() => onSort(accessor)}>
    {label}
  </button>
);

export default sortableHeader;
